<mat-form-field subscriptSizing="dynamic">
    @if (label()) {
        <mat-label>
            {{ label() }}
        </mat-label>
    }

    <input
        #control
        matInput
        [disabled]="disabled()"
        [ngModel]="internalValue()"
        [placeholder]="label() || placeholder()"
        [required]="required()"
        [maxLength]="maxLength()"
        [type]="type()"
        (change)="onValueChanged()"
        (ngModelChange)="onNgModelChanged($event)"
        (blur)="onBlur()"
        (focus)="onFocus()"
        (keyup)="keyPressed($event)" />
    @if (hint()) {
        <mat-hint>{{ hint() }}</mat-hint>
    }
    @if (hasSuffix()) {
        <ng-container matSuffix>
            <ng-content select="[suffix]" />
        </ng-container>
    }
    @if (hasPrefix()) {
        <ng-container matPrefix>
            <ng-content select="[prefix]" />
        </ng-container>
    }
    @if (hasError()) {
        <ng-container matError>
            <ng-content select="[error]" />
        </ng-container>
    }
</mat-form-field>
